import { Heading } from "@/components/typography";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import type { ConfirmKind } from "../campaign";

type OpenCloseDialogProps = {
    confirmKind: ConfirmKind;
    onOpenChange: (open: boolean) => void;
    actionPending: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

/** Confirm opening or closing the opportunity to new pitches. */
export function OpenCloseDialog({
    confirmKind,
    onOpenChange,
    actionPending,
    onConfirm,
    onCancel,
}: OpenCloseDialogProps) {
    return (
        <Dialog open={confirmKind != null} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md" showCloseButton={false}>
                <DialogHeader>
                    <DialogTitle render={<Heading type="h3" tag="h2" />}>
                        {confirmKind === "close" ? "Close this opportunity?" : "Open this campaign for pitches?"}
                    </DialogTitle>
                    <DialogDescription className="text-foreground">
                        {confirmKind === "close"
                            ? "Managers will not be able to submit new pitches. Existing pitches are left as they are."
                            : "Managers will be able to submit pitches for this campaign."}
                    </DialogDescription>
                </DialogHeader>
                {/* Side-by-side confirm and cancel, matching Lists delete. */}
                <DialogFooter className="sm:justify-stretch">
                    <Button className="flex-1" disabled={actionPending} onClick={onConfirm}>
                        {confirmKind === "close" ? "Close opportunity" : "Open for pitches"}
                    </Button>
                    <Button variant="secondary" className="flex-1" disabled={actionPending} onClick={onCancel}>
                        Back to Safety
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
